/**
 * @generated SignedSource<<98c2cb5b762ebeb5ed643af34a95c10d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postAttachmentsPreview_post$data = {
  readonly attachments: ReadonlyArray<{
    readonly id: string;
    readonly originalName: string;
    readonly signedUrl: string;
    readonly size: string | null | undefined;
  }> | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "postAttachmentsPreview_post";
};
export type postAttachmentsPreview_post$key = {
  readonly " $data"?: postAttachmentsPreview_post$data;
  readonly " $fragmentSpreads": FragmentRefs<"postAttachmentsPreview_post">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postAttachmentsPreview_post",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signedUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "9bec5a283e79f316befac3a580df8bab";

export default node;
